// Bugsnag
import Bugsnag from '@bugsnag/js'
import BugsnagPerformance, { DefaultRoutingProvider } from '@bugsnag/browser-performance'

// myUMBC environment and version
function getMetaContent(name) {
    const meta = document.querySelector(`meta[name="${name}"]`)
    return meta ? meta.getAttribute('content') : null
}

const myumbcEnvironment = getMetaContent('myumbc:environment') || 'production'
const myumbcBuild = getMetaContent('myumbc:build')

// Custom routing for parameterized routes

function resolveRoute (url) {
  // Normalize /account/invite
  if (url.pathname.startsWith('/account/invite')) {
    return '/account/invite'
  }

  // Profile sections to normalize
  const profileSections = [
    'notifications', 'graduation', 'degree', 'registration', 'grades',
    'blackboard', 'billing', 'financialaid', 'campuscard', 'careercenter',
    'parking', 'about'
  ]

  // Match /profile or /profile/section at the start of the path only
  const profileSectionRegex = new RegExp(`^/profile(?:/(${profileSections.join('|')}))?(?:/)?$`, 'i')
  if (profileSectionRegex.test(url.pathname)) {
    return url.pathname
  }

  // Match /profile/userid or /profile/userid/section at the start of the path only
  const profileUserRegex = new RegExp(`^/profile/[^/]+(?:/(${profileSections.join('|')}))?(?:/)?$`, 'i')
  const match = url.pathname.match(profileUserRegex)
  if (match) {
    return `/profile/:user${match[1] ? '/' + match[1] : ''}`
  }

  return url.pathname
}


Bugsnag.start({
    apiKey: 'd81a991c4d14f69c669c983c6ac77fd0',
    releaseStage: myumbcEnvironment,
    appVersion: myumbcBuild,
    //enabledReleaseStages: ['production', 'staging'],
})

BugsnagPerformance.start({
    apiKey: '6af745cb1e8314dc8c0004b36e38c653',
    releaseStage: myumbcEnvironment,
    appVersion: myumbcBuild,
    routingProvider: new DefaultRoutingProvider(resolveRoute)
})

// This is the Javascript one -- can only have one active at a time
// BugsnagPerformance.start({ apiKey: 'd81a991c4d14f69c669c983c6ac77fd0' })
